(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-live-embroidery-inquiry"] && !Shopify.designMode) return;
  try {
    
function initializeAMLive(root) {
  if (root.dataset.amInitialized) return;
  root.dataset.amInitialized = 'true';
  const text = JSON.parse(root.querySelector('[data-am-strings]').textContent);
  const get = (id) => root.querySelector('#AMLive' + id);
  const format = (message, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll('{' + key + '}', String(value)), message);
  const update = () => {
    const hours = Number(get('Hours').value);
    const product = get('Product').value;
    const design = get('Design').value;
    const placements = get('Placements').value;
    const machines = Number(get('Machines').value);
    const operators = Number(get('Operators').value);
    const quantity = Number(get('Quantity').value);
    const exampleHours = hours || 4;
    root.querySelector('[data-am-caption]').textContent = format(text.caption, {hours: exampleHours});
    root.querySelectorAll('[data-am-range]').forEach((cell) => {
      const count = Number(cell.dataset.amRange);
      cell.textContent = (exampleHours * count * 6) + '–' + (exampleHours * count * 7);
    });
    root.querySelectorAll('[data-am-row]').forEach((row) => row.classList.toggle('am-live-selected', Number(row.dataset.amRow) === machines && operators >= machines));
    root.querySelector('[data-am-product-note]').textContent = text[product] || text.product_default;
    let note = text.select;
    if (get('Hours').value && !hours) note = text.hours_review;
    else if (hours && product && design && placements) {
      if (!['totes', 'linens'].includes(product) || design !== 'simple' || placements !== '1') note = text.review;
      else if (!machines || !operators) note = text.staff_review;
      else if (operators < machines) note = text.shared;
      else {
        const low = hours * machines * 6;
        const high = hours * machines * 7;
        note = format(text.estimate, {low, high, hours, machines});
        if (Number.isInteger(quantity) && quantity > 0) {
          const demand = quantity > high ? text.demand_high : quantity > low ? text.demand_risk : text.demand_fit;
          note += ' ' + format(demand, {quantity});
        }
      }
    }
    if (machines && operators && operators < machines) note = text.shared + ' ' + (note === text.shared ? '' : note);
    root.querySelector('[data-am-estimate]').textContent = note.trim();
    root.querySelector('[data-am-summary]').value = note.trim();
  };
  root.addEventListener('change', update);
  root.addEventListener('input', update);
  root.querySelector('form').addEventListener('submit', update);
  update();
}
document.querySelectorAll('[data-am-live]').forEach(initializeAMLive);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-am-live]').forEach(initializeAMLive));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
